import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

export const createCotizacionHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(`${env.API_URL}/createCotizacion`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getCotizacionPorIdProveedorHttp = async (datos?: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getCotizacionPorIdProveedor`, {
      params: datos,
    });
    return response?.data?.data || response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const gestionarProductoProveedorHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/gestionarProductoProveedor`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const noDisponibleProductoProveedorHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/noDisponibleProductoProveedor`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getCotizacionesHttp = async (params?: { search?: string }) => {
  try {
    const url = new URL(`${env.API_URL}/getCotizaciones`);

    if (params?.search) url.searchParams.append("search", params.search);

    const response = await axios.get(url.toString());
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getCotizacionPorIdHttp = async (datos?: { id_cotizacion: number | string }) => {
  try {
    const response = await axios.get(`${env.API_URL}/getCotizacionPorId`, {
      params: datos,
    });
    return response?.data?.data || response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const onTodosGestionadosHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/onTodosGestionados`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const enviarAutorizarEquipoHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/enviarAutorizarEquipo`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};

export const marcarSeleccionadosHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/marcarProductosSeleccionados`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};

export const recotizarProductosHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/recotizarProductos`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};

export const getBitacoraCotizacionHttp = async (id_cotizacion: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getBitacoraCotizacion`, {
      params: { id_cotizacion },
    });
    const body = response?.data;

    if (Array.isArray(body)) return body;
    if (Array.isArray(body?.data)) return body.data;

    if (body?.data && Array.isArray(body.data.eventos)) return body.data;
    if (Array.isArray(body?.eventos)) return body;

    return [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};